module.exports = __webpack_public_path__ + "static/img/Sambhajirao.b99e590.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sambhajirao.jpg
// module id = GfeC
// module chunks = 0